import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "download-wrap"
};
const _hoisted_2 = {
  class: "dialog-content"
};
const _hoisted_3 = {
  class: "header-section"
};
const _hoisted_4 = {
  class: "qr-section"
};
const _hoisted_5 = {
  class: "scan-hint"
};
const _hoisted_6 = {
  class: "instructions"
};
const _hoisted_7 = {
  class: "instruction-title"
};
import { ref, computed, watch } from "vue";
import { CloseBold, FullScreen, InfoFilled } from "@element-plus/icons-vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadQrcode',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  emits: ["updateDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const qrcode = ref(process.env.VUE_APP_WEB_URL + "/download.html");
    //接收父组件传参
    const props = __props;
    //修改父组件参数值
    const emit = __emit;
    // 本地响应式变量代理 props.showDialog
    const dialogVisible = ref(props.showDialog);
    // 监听 props.showDialog 变化，同步更新本地变量
    watch(() => props.showDialog, newVal => {
      dialogVisible.value = newVal;
    });
    const closeDialog = () => {
      emit("updateDialog", false);
    };
    // 计算二维码尺寸响应式
    const qrSize = computed(() => {
      return window.innerWidth > 768 ? 200 : 150;
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_Qrcode = _resolveComponent("Qrcode");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        onClose: closeDialog,
        "show-close": false,
        width: "320px",
        class: "download-dialog",
        modal: true,
        "lock-scroll": true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
          class: "title"
        }, "移动端APP下载", -1)), _createVNode(_component_el_button, {
          class: "close-btn",
          onClick: closeDialog,
          circle: "",
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_Qrcode, {
          value: qrcode.value,
          style: _normalizeStyle({
            width: qrSize.value + 'px',
            height: qrSize.value + 'px'
          }),
          class: "qrcode-display"
        }, null, 8, ["value", "style"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
          class: "scan-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(FullScreen))]),
          _: 1
        }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "扫描二维码下载应用", -1))])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
          _: 1
        }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "下载说明", -1))]), _cache[4] || (_cache[4] = _createElementVNode("ul", {
          class: "steps-list"
        }, [_createElementVNode("li", {
          class: "step-item"
        }, [_createElementVNode("span", {
          class: "step-number"
        }, "1"), _createElementVNode("span", {
          class: "step-text"
        }, "请使用手机浏览器扫码下载")]), _createElementVNode("li", {
          class: "step-item"
        }, [_createElementVNode("span", {
          class: "step-number"
        }, "2"), _createElementVNode("span", {
          class: "step-text"
        }, "微信扫码后点击右上角[...]")]), _createElementVNode("li", {
          class: "step-item"
        }, [_createElementVNode("span", {
          class: "step-number"
        }, "3"), _createElementVNode("span", {
          class: "step-text"
        }, "选择浏览器打开并下载")])], -1))])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});